<div class="main-container">
    <div class="texto">
        <mat-spinner></mat-spinner>
        <h2>{{ 'texto-redireccionando' |  translate }}</h2>
        <p>{{ 'porfavor-espera' |  translate }}</p>
    </div>
</div>
